import type { ModifiedConfigChange } from "./model-expert-types";

/** Returns the names of the sub predictors that the Model Expert has modified */
export function getChangedSubPredictorNames(changes: ModifiedConfigChange[]) {
  return new Set(
    changes
      .map((change) =>
        change.type === "add-descriptor"
          ? change.data.target.name
          : change.type === "remove-descriptor"
            ? change.data.target.name
            : change.type === "add-node"
              ? change.data.node.name
              : undefined,
      )
      .filter(Boolean),
  );
}

export function getEdgeIdentifier(source: string, target: string) {
  return `${source}::${target}`;
}

/** Returns identifiers representing the edges that the Model Expert has modified */
export function getTouchedEdgeIdentifiers({
  changes,
  descriptorSourceToPredictorFormIdLookup,
  subPredictorNameToFormIdLookup,
}: {
  changes: ModifiedConfigChange[];
  /** Needed because the descriptor sources in the `changes` are bugged PLA-13826 */
  descriptorSourceToPredictorFormIdLookup: Partial<Record<string, string>>;
  subPredictorNameToFormIdLookup: Partial<Record<string, string>>;
}) {
  return new Set(
    changes.flatMap((change) =>
      change.type === "add-descriptor"
        ? getEdgeIdentifier(
            descriptorSourceToPredictorFormIdLookup[
              change.data.descriptor.descriptor_key
            ] ?? "",
            subPredictorNameToFormIdLookup[change.data.target.name] ?? "",
          )
        : change.type === "add-node"
          ? Object.keys(change.data.descriptor_sources).map((descriptorKey) =>
              getEdgeIdentifier(
                descriptorSourceToPredictorFormIdLookup[descriptorKey] ?? "",
                subPredictorNameToFormIdLookup[change.data.node.name] ?? "",
              ),
            )
          : [],
    ),
  );
}
